import { render, staticRenderFns } from "./ImageConfig.vue?vue&type=template&id=ab6978ec&scoped=true&"
import script from "./ImageConfig.vue?vue&type=script&lang=js&"
export * from "./ImageConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6978ec",
  null
  
)

export default component.exports